import { Button } from "antd";
import React from "react";
interface ButtonTransparentProps {
  onClick?: () => void;
  title: any;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactNode;
}
const TransparentButton = ({ ...props }: ButtonTransparentProps) => {
  return (
    <Button
      {...props}
      title=""
      className={`takaful--tansparent-button ${props.className}`}
      icon={props.icon}
    >
      {props.title}
    </Button>
  );
};

export default TransparentButton;
